import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import { rOyakKiraBilgileriUstBilgi } from '../../../../api/models/rOyakKiraBilgileriUstBilgi';

export default ApiBaseReducer<
  pList,
  IInputDataStateModel<pList, rOyakKiraBilgileriUstBilgi>,
  rOyakKiraBilgileriUstBilgi
>(
  ActionSubTypes.API_OYAKKIRABILGILERIUSTBILGI,
  DefaultInputDataStateModel<pList, rOyakKiraBilgileriUstBilgi>()
);
